import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";
import ServicesSlider from "@/pages/services/components/ServicesSlider";
import ServiceCards from "@/components/feature/ServiceCards";

const COMPANY_NAME = "NetBasis International";

const texts = {
  title: "Our Services",
  h1Text:
    "Comprehensive commercial and technical services for your sustainable business success. As an experienced local partner, we guide foreign ICT manufacturers through the development of new markets and offer tailored solutions for every single step of your expansion.",
  introParagraphs: [
    "We at NetBasis International offer foreign manufacturers from the telecommunications and IT industry a wide spectrum of commercial and technical services as well as consulting and training to support them quickly and efficiently on their way into new markets. Our clear focus lies on achieving your growth objectives throughout the entire German-speaking economic area (DACH region).",
    "To help you find the desired area of expertise more quickly, we have divided our portfolio into four specialized sections:",
    "If you want to actively involve us in your new business and have us perform real tasks, please look into \"Business Development\" to explore our various services and select what we can concretely do for you. If you would like to know us by your side as pure advisors, please have a look at \"Consulting\". If you wish to engage us \"for a limited time\" in one of our specialist areas, simply click directly on \"Interim Management\". Or, if you would like to draw on our know-how for pure training and coaching purposes, please browse the corresponding section.",
  ],
  sectionTitle:
    "Together toward operational excellence and sustainable market success",
  belowText:
    "Whatever your idea may be, NetBasis International helps you precisely specify the goals and visions of your market entry plan. As on-site industry experts, we assist you in permanently reviewing all processes and agilely adapting them over and over again to the individual requirements of the new markets. In doing so, we do not view ourselves as an external service provider, but rather as loyal and fully integrated members of your own team who are deeply connected to your project. We possess the fine intuition and well-founded expertise for local market mechanisms that are absolutely essential to turn your international venture into a real and lasting success. Through this deep commitment and our clear focus on measurable results, we secure your strong and highly competitive market presence step by step.",
  claim: "NetBasis International - drive to excellence with excellent drivers !",
};

const cardTexts = {
  titles: [
    "Business Development",
    "Consulting Services",
    "Interim Management",
    "Training & Coaching",
  ],
  descriptions: [
    "Are you looking for active support and want to easily hand over operational tasks? Then choose from our services.",
    "Would you like to have us purely as consultants by your side? Then simply take a look at our portfolio of services.",
    "Do you want to hire us \"on a temporary basis\" in one of our fields? Then find all the details here.",
    "Would you like to draw on our know-how for pure training and/or coaching purposes? Then take a look around here.",
  ],
  readMore: "Read more",
};

const renderWithBold = (text: string) => {
  const parts = text ? text.split(COMPANY_NAME) : [];
  return parts.map((part, i) => (
    <span key={i}>
      {part}
      {i < parts.length - 1 && (
        <strong className="text-primary-600">{COMPANY_NAME}</strong>
      )}
    </span>
  ));
};

export default function ServicesEnPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <PageHead
        title="Our Services | NetBasis International"
        description="Comprehensive commercial and technical services, consulting, and training for your successful expansion into the DACH market."
        ogUrl="https://net-basis.net/en/services"
      />
      <Header />

      <main className="flex-1 pt-20 md:pt-24">
        <ServicesSlider />

        {/* Content */}
        <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto">
            {/* WIDGET 1 - Heading (h2) */}
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
              {texts.title}
            </h2>

            {/* WIDGET 2 - H1: bold intro */}
            <h1 className="text-foreground-950 font-semibold text-sm md:text-base leading-relaxed mb-4">
              {texts.h1Text}
            </h1>

            {/* WIDGET 3 - body text */}
            <div className="space-y-4 font-body text-sm md:text-base text-foreground-950 leading-relaxed">
              {texts.introParagraphs.map(
                (text, idx) =>
                  text && (
                    <p key={idx}>{renderWithBold(text)}</p>
                  )
              )}
            </div>
          </div>
        </section>

        {/* Service Cards */}
        <ServiceCards
          namespace="services"
          titleKeys={[]}
          descriptionKeys={[]}
          readMoreKey=""
          texts={cardTexts}
        />

        {/* WIDGET 4 + 5 - green h2 + paragraph */}
        <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
              {texts.sectionTitle}
            </h2>
            <div className="space-y-4 font-body text-sm md:text-base text-foreground-950 leading-relaxed">
              <p>{renderWithBold(texts.belowText)}</p>
            </div>
          </div>
        </section>

        {/* Bottom claim */}
        <section className="py-6 md:py-10 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto text-center">
            <p className="font-heading text-lg md:text-xl font-bold text-primary-600">
              {texts.claim}
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}